module.exports = __webpack_public_path__ + "img/downApp.aa9de3ac.png";